<template>
  <div>
    <span v-if="data && data.type === 'destination'">
      <span v-for="child in data.children[0].children" v-if="data.children && data.children.length > 0 && data.children[0].children && data.children[0].children.length > 0">
        <vuestic-tree-category :isOpen="false" :data="child" :label="[child.name]" :key="child.name">
          <tree :data="child">
          </tree>
        </vuestic-tree-category>
      </span>
      <vuestic-tree-node :key="data.name" v-else>
        {{ child.name }}
      </vuestic-tree-node>
    </span>
    <span v-else>
      <span v-for="child in data.children" v-if="data.children && data.children.length > 0">
        <vuestic-tree-category :isOpen="false" :data="child" :label="[child.name]" :key="child.name">
          <tree :data="child">
          </tree>
        </vuestic-tree-category>
      </span>
      <vuestic-tree-node :key="data.name" v-else>
        {{ child.name }}
      </vuestic-tree-node>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'tree',
    data: function () {
      return {
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../../sass/variables";
  .tree {
    max-height: 100px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/communication-tab/Tree.vue